import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Label,
  Col,
  Spinner,
  Form,
  FormGroup,
} from "reactstrap";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";

function AbonosProveedoresCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ABONOS_PROVEEDORES = process.env.REACT_APP_URL_ABONOS_PROVEEDORES;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  // Alta de anticipo desde esta misma pantalla (ref propia de Cuory)
  const URL_ANTICIPOS_PROVEEDORES =
    process.env.REACT_APP_URL_ANTICIPOS_PROVEEDORES;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [proveedores, setProveedores] = useState([]);
  const [valueProveedor, setValueProveedor] = useState(null);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [concepto, setConcepto] = useState("");
  const [tipoCambio, setTipoCambio] = useState(1);

  const [selectedBanco, setSelectedBanco] = useState("");
  const [bancos, setBancos] = useState([]);
  const [moneda, setMoneda] = useState("");

  const [validaBoton, setValidaBoton] = useState(true);
  const [total, setTotal] = useState(0);
  const [montoRepartir, setMontoRepartir] = useState(0);

  const [inputFields, setInputFields] = useState([]);
  const [codigoAgrupado] = useState(uuidv4());

  // En el mismo paso se pueden capturar abonos a notas + un anticipo.
  // El anticipo va en un renglon aparte debajo de la tabla.
  const [importeAnticipo, setImporteAnticipo] = useState(0);
  const [ordenesCompra, setOrdenesCompra] = useState([]);
  const [selectedOC, setSelectedOC] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  useMemo(() => {
    axios
      .get(`${URL_PROVEEDORES}Tipo/China`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setProveedores(response.data || []);
      })
      .catch((err) => console.log(err));

    axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setBancos(response.data || []);
      })
      .catch((err) => console.log(err));
  }, []);

  // Cargar OCs activas del proveedor para el renglon de anticipo
  useEffect(() => {
    if (!selectedProveedor) {
      setOrdenesCompra([]);
      setSelectedOC("");
      setImporteAnticipo(0);
      return;
    }
    axios
      .get(URL_ORDENES_COMPRA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const ocs = (res.data || []).filter(
          (o) =>
            o.proveedores?.[0]?._id === selectedProveedor &&
            o.is_active === "Si"
        );
        setOrdenesCompra(ocs);
      })
      .catch((err) => console.log(err));
  }, [selectedProveedor]);

  // Cargar notas CxP pendientes del proveedor (saldo > 0)
  useEffect(() => {
    if (!selectedProveedor) {
      setInputFields([]);
      setTotal(0);
      return;
    }
    axios
      .get(`${URL_NOTAS_CXP}Proveedor/${selectedProveedor}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        const pendientes = (response.data || [])
          .filter((n) => Number(n.saldo) > 0 && n.is_active === "Si")
          .map((a) => {
            const emb =
              a.embarques && a.embarques.length > 0
                ? `Emb #${a.embarques[0].idEmbarques}`
                : `Nota #${a.idNotasCxP}`;
            // Concepto del gasto (solo notas tipo Gasto)
            const gastoTxt =
              a.tipo === "Gasto" && a.concepto ? ` - ${a.concepto}` : "";
            // Numeros de OC relacionadas
            const ocTxt =
              a.ordenesCompraNumeros && a.ordenesCompraNumeros.length
                ? ` / OC ${a.ordenesCompraNumeros.join(", ")}`
                : "";
            return {
              id: a._id,
              fecha: a.fecha,
              embarque: emb + gastoTxt + ocTxt,
              numero: a.idNotasCxP,
              total_costo: Number(a.total_costo || 0),
              saldo: Number((a.saldo || 0).toFixed(2)),
              importe: 0,
              observaciones: "NA",
            };
          })
          .sort((a, b) => (a.fecha > b.fecha ? 1 : -1));
        setInputFields(pendientes);
        setTotal(0);
      })
      .catch((err) => console.log(err));
  }, [selectedProveedor]);

  const handleChangeInputImporte = (value, name, id) => {
    const next = inputFields.map((i) => {
      if (id !== i.id) return i;
      const importeNum = parseFloat(value) || 0;
      if (importeNum > i.saldo) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El Pago excede el Saldo",
        });
        return i;
      }
      return { ...i, importe: value };
    });
    setInputFields(next);
    ActualizaTotales(next);
  };

  const handleChangeInputObs = (id, event) => {
    const next = inputFields.map((i) =>
      i.id === id ? { ...i, observaciones: event.target.value } : i
    );
    setInputFields(next);
  };

  function ActualizaTotales(rows = inputFields) {
    const TE = rows.reduce((acc, r) => acc + (parseFloat(r.importe) || 0), 0);
    setTotal(TE);
  }

  // Reparte un monto total entre las notas con saldo, proporcional al saldo de cada una.
  // Como el monto repartido nunca excede la suma de saldos, ninguna nota recibe mas que su saldo.
  const repartirProporcional = () => {
    const monto = Number(montoRepartir) || 0;
    const totalSaldo = inputFields.reduce(
      (a, r) => a + (Number(r.saldo) || 0),
      0
    );
    if (monto <= 0 || totalSaldo <= 0) {
      Swal.fire({
        icon: "info",
        title: "Sin datos para repartir",
        text: "Captura un monto mayor a 0 y que haya notas con saldo.",
      });
      return;
    }
    // No se reparte mas que el total adeudado
    const montoAplicar = Math.min(monto, totalSaldo);

    let next = inputFields.map((r) => {
      const saldo = Number(r.saldo) || 0;
      if (saldo <= 0) return { ...r, importe: 0 };
      const imp = Math.round((saldo / totalSaldo) * montoAplicar * 100) / 100;
      return { ...r, importe: imp };
    });

    // Ajuste de redondeo: la suma debe cuadrar con el monto aplicado
    const suma = next.reduce((a, r) => a + (Number(r.importe) || 0), 0);
    const dif = Math.round((montoAplicar - suma) * 100) / 100;
    if (dif !== 0) {
      let idxMax = -1;
      let maxSaldo = -1;
      next.forEach((r, i) => {
        const saldo = Number(r.saldo) || 0;
        const nuevo = (Number(r.importe) || 0) + dif;
        if (saldo > maxSaldo && nuevo >= 0 && nuevo <= saldo + 0.001) {
          maxSaldo = saldo;
          idxMax = i;
        }
      });
      if (idxMax >= 0) {
        next[idxMax] = {
          ...next[idxMax],
          importe:
            Math.round(((Number(next[idxMax].importe) || 0) + dif) * 100) / 100,
        };
      }
    }

    setInputFields(next);
    ActualizaTotales(next);
    if (montoAplicar < monto) {
      Swal.fire({
        icon: "warning",
        title: "Monto ajustado",
        text: `El total adeudado es menor al monto capturado; se repartio solo ${new Intl.NumberFormat(
          "en-US",
          { style: "currency", currency: "USD" }
        ).format(montoAplicar)}.`,
      });
    }
  };

  function jalaBanco(e) {
    setSelectedBanco(e);
    bancos.map((a) => {
      if (a._id == e) setMoneda(a.moneda);
    });
  }

  const savePago = () => {
    const totalAbonos = Number(total) || 0;
    const totalAnticipo = Number(importeAnticipo) || 0;
    if (
      !selectedProveedor ||
      selectedBanco === "" ||
      (totalAbonos <= 0 && totalAnticipo <= 0)
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes seleccionar proveedor y banco, y capturar al menos un abono o un anticipo",
      });
      return;
    }
    if (totalAbonos > 0 && concepto === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes seleccionar concepto para los abonos a notas",
      });
      return;
    }

    Swal.fire({
      title: "Estas seguro?",
      text: "Se registrará el pago",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      setValidaBoton(false);
      toggleProgreso();

      // Si se capturo importe de anticipo, crearlo primero
      if (totalAnticipo > 0) {
        try {
          const antRes = await axios.post(
            URL_ANTICIPOS_PROVEEDORES,
            {
              fecha,
              importe: totalAnticipo,
              formaPago: concepto || "Anticipo",
              bancos: selectedBanco,
              proveedores: selectedProveedor,
              ordenesCompra: selectedOC || null,
              utilizado: 0,
              saldo: totalAnticipo,
              tipoCambio: Number(tipoCambio) || 1,
              observaciones: "NA",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          await axios.post(
            URL_MOVIMIENTOS_BANCOS,
            {
              fecha,
              importe: -totalAnticipo,
              tipo: "Egreso",
              bancos: selectedBanco,
              anticiposProveedores: antRes.data._id,
              moneda,
              tipoCambio: 1,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          axios.post(
            URL_LOGS,
            {
              tipo: "Crear Anticipo Proveedor",
              detalle: `Fecha: ${fecha} / Proveedor: ${selectedProveedor} / Importe: ${totalAnticipo}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
        } catch (err) {
          console.log(err);
          Swal.fire({ icon: "error", title: "Oops...", text: "Falló el anticipo" });
          setValidaBoton(true);
          setModalProgreso(false);
          return;
        }
      }

      const filas = inputFields.filter((a) => Number(a.importe) > 0);
      let pendientes = filas.length;
      if (pendientes === 0) {
        // Solo se pidio anticipo: cerrar aqui con exito
        if (totalAnticipo > 0) {
          Swal.fire("Good job!", "Anticipo creado con exito", "success");
          setTimeout(() => window.location.reload(), 1000);
          return;
        }
        setModalProgreso(false);
        setValidaBoton(true);
        return;
      }

      filas.forEach((a) => {
        axios
          .post(
            URL_ABONOS_PROVEEDORES,
            {
              fecha,
              importe: parseFloat(a.importe),
              proveedores: selectedProveedor,
              concepto,
              tipoCambio,
              montoPesos: parseFloat(a.importe) * (Number(tipoCambio) || 1),
              bancos: selectedBanco,
              notasCxP: a.id,
              observaciones: a.observaciones,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((data) => {
            axios
              .post(
                `${URL_MOVIMIENTOS_BANCOS}`,
                {
                  fecha,
                  importe: -parseFloat(a.importe),
                  tipo: "Egreso",
                  bancos: selectedBanco,
                  abonosProveedores: data.data._id,
                  moneda,
                  tipoCambio: 1,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .catch((err) => console.log(err));

            pendientes -= 1;
            if (pendientes === 0) {
              axios.post(
                URL_LOGS,
                {
                  tipo: "Crear Pago Proveedor",
                  detalle: `Fecha: ${fecha} / Proveedor: ${selectedProveedor} / Total: ${total}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );
              Swal.fire("Good job!", "Creado con exito", "success");
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
            });
            console.log(error);
            setValidaBoton(true);
            setModalProgreso(false);
          });
      });
    });
  };

  const options = proveedores.map((option) => {
    const junta = option.nombre_comercial;
    const firstLetter = option.nombre_comercial[0]?.toUpperCase() || "0";
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pagoProveedores ? (
        <div className="card container col-sm-11">
          <h3 align="center">Captura un Pago a Proveedor</h3>
          <Form>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha</Label>
                  <Input
                    type="date"
                    value={fecha}
                    required
                    onChange={(e) => setFecha(e.target.value)}
                  />
                </Col>
                <Col md={3}>
                  <Label className="mr-sm-2">Proveedor</Label>
                  <Autocomplete
                    size="small"
                    value={valueProveedor}
                    onChange={(event, sel) => {
                      if (sel) {
                        setValueProveedor(sel);
                        setSelectedProveedor(sel._id);
                      } else {
                        setValueProveedor(null);
                        setSelectedProveedor("");
                      }
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.codigo} {option.nombre_comercial}
                      </React.Fragment>
                    )}
                  />
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Concepto</Label>
                  <Input
                    type="select"
                    value={concepto}
                    onChange={(e) => setConcepto(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    <option value="Abono">Abono</option>
                    <option value="Bonificacion">Bonificacion</option>
                    <option value="Descuento">Descuento</option>
                  </Input>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Banco</Label>
                  <Input
                    type="select"
                    value={selectedBanco}
                    onChange={(e) => jalaBanco(e.target.value)}
                  >
                    <option value="">Selecciona un Banco</option>
                    {bancos
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((a) => (
                        <option value={a._id}>
                          {a.banco} {a.cuenta}
                        </option>
                      ))}
                  </Input>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">TC</Label>
                  <Input
                    type="number"
                    min="0"
                    step="any"
                    value={tipoCambio}
                    onChange={(e) => setTipoCambio(e.target.value)}
                  />
                </Col>
                <Col md={2}>
                  <h4 align="right">
                    Total Pago{"  "}
                    <Badge
                      id="Total"
                      color="danger"
                      className="BadgeSize badge-pill"
                    >
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(total)}
                    </Badge>
                  </h4>
                  <h6 align="right">
                    Total Pesos{"  "}
                    <Badge color="dark" className="badge-pill">
                      {new Intl.NumberFormat("es-MX", {
                        style: "currency",
                        currency: "MXN",
                        maximumFractionDigits: 2,
                      }).format((Number(total) || 0) * (Number(tipoCambio) || 1))}
                    </Badge>
                  </h6>
                </Col>
              </Row>
              {/* <Row>
                <Col md={3}>
                  <Label className="mr-sm-2">Monto total a repartir (USD)</Label>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    defaultValue={0}
                    decimalsLimit={2}
                    value={montoRepartir}
                    className="form-control"
                    onValueChange={(value) => setMontoRepartir(value)}
                  />
                </Col>
                <Col md="auto" className="d-flex flex-column">
                  <Label className="mr-sm-2" style={{ visibility: "hidden" }}>
                    .
                  </Label>
                  <Button
                    color="info"
                    onClick={repartirProporcional}
                    disabled={!inputFields.length}
                  >
                    Repartir proporcional
                  </Button>
                </Col>
              </Row> */}
              <br />
              <Row>
                <Table striped borderless>
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Nota / Embarque</th>
                      <th>Total</th>
                      <th>Abonado</th>
                      <th>Saldo</th>
                      <th>Importe</th>
                      <th>Observaciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inputFields.map((a) => (
                      <tr key={a.id}>
                        <td>{a.fecha}</td>
                        <td>{a.embarque}</td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.total_costo)}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.total_costo - a.saldo)}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.saldo)}
                        </td>
                        <td>
                          <CurrencyInput
                            intlConfig={{
                              locale: "en-US",
                              currency: "USD",
                            }}
                            prefix="$"
                            name="importe"
                            defaultValue={0}
                            decimalsLimit={2}
                            value={a.importe}
                            className={`form-control`}
                            onValueChange={(value, name) =>
                              handleChangeInputImporte(value, name, a.id)
                            }
                          />
                        </td>
                        <td>
                          <Input
                            type="text"
                            name="observaciones"
                            value={a.observaciones}
                            onChange={(e) => handleChangeInputObs(a.id, e)}
                          />
                        </td>
                      </tr>
                    ))}
                    {inputFields.length === 0 && (
                      <tr>
                        <td colSpan="7" align="center">
                          {selectedProveedor
                            ? "Sin notas pendientes para este proveedor"
                            : "Selecciona un proveedor para ver sus notas pendientes"}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="negrita" align="center">
                        Total
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(total)}
                      </td>
                      <td></td>
                    </tr>
                    {/* Renglon extra para dar de alta un anticipo en el mismo paso (deshabilitado a peticion) */}
                    {/* <tr style={{ backgroundColor: "#fff3cd" }}>
                      <td colSpan="2" className="negrita">
                        Anticipo (opcional)
                      </td>
                      <td colSpan="2">
                        <Input
                          type="select"
                          value={selectedOC}
                          onChange={(e) => setSelectedOC(e.target.value)}
                          disabled={!selectedProveedor}
                          style={{ backgroundColor: "#ffffff", color: "#212529" }}
                        >
                          <option value="">Sin OC</option>
                          {ordenesCompra
                            .sort((a, b) =>
                              a.idOrdenCompra < b.idOrdenCompra ? 1 : -1
                            )
                            .map((a) => (
                              <option key={a._id} value={a._id}>
                                OC #{a.idOrdenCompra} / {a.fecha} / $
                                {Number(a.total_general).toFixed(2)}
                              </option>
                            ))}
                        </Input>
                      </td>
                      <td className="negrita" align="right">
                        Importe:
                      </td>
                      <td>
                        <CurrencyInput
                          intlConfig={{ locale: "en-US", currency: "USD" }}
                          prefix="$"
                          defaultValue={0}
                          decimalsLimit={2}
                          value={importeAnticipo}
                          className={`form-control`}
                          onValueChange={(value) =>
                            setImporteAnticipo(value || 0)
                          }
                          disabled={!selectedProveedor}
                        />
                      </td>
                      <td></td>
                    </tr> */}
                  </tbody>
                </Table>
              </Row>
            </FormGroup>
            <br />
            <Row>
              {validaBoton ? (
                <Button className="btn btn-success" onClick={savePago}>
                  Registrar
                </Button>
              ) : (
                <Button className="btn btn-success" disabled>
                  Registrar
                </Button>
              )}
              <Button
                href="/ListadoAbonosProveedores"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Row>
          </Form>
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default AbonosProveedoresCreate;
